<template>
  <div class="main-container">
    <router-view></router-view>
    <!-- Navbar section -->
    <HeaderSoftware />

    <!-- breadcrumb strat -->
    <Breadcrumb>
      <template slot="breadcrumb">
        <div class="breadcrumb_box text-center">
          <h2 class="breadcrumb-title">{{$t('wheretofindus')}}</h2>
          <!-- breadcrumb-list start -->
          <ul class="breadcrumb-list">
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{$t('home')}}</router-link>
            </li>
            <li class="breadcrumb-item active">{{$t('wheretofindus')}}</li>
          </ul>
          <!-- breadcrumb-list end -->
        </div>
      </template>
    </Breadcrumb>
    <!-- breadcrumb end -->

    <CurveShape class="curve-bottom">
      <template v-slot:bgcolor>
        <path
          style="fill: #f6f5f9;
                    stroke-miterlimit:10;"
          d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"
        />
      </template>
    </CurveShape>

    <!-- footer section -->
    <FooterMain />

    <!-- offcanvas search component -->
    <OffcanvasSearchBox />

    <!-- off-canvas mobile menu -->
    <OffCanvasMobileMenu />
  </div>
</template>
<script>
import HeaderSoftware from "../components/HeaderSoftware";
import Breadcrumb from "@/components/Breadcrumb";
import FooterMain from "@/components/FooterMain";
import OffcanvasSearchBox from "@/components/OffcanvasSearchBox";
import OffCanvasMobileMenu from "@/components/OffCanvasMobileMenu";
import CurveShape from "../components/CurveShape";
import TabContentFour from "../components/TabContentFour";
export default {
  components: {
    HeaderSoftware,
    Breadcrumb,
    FooterMain,
    OffcanvasSearchBox,
    OffCanvasMobileMenu,
    CurveShape,
    TabContentFour
  }
};
</script>
